export default {
      id: "inputNumberArrowUp-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#inputNumberArrowUp-usage",
      toString: function () {
        return this.url;
      }
    }